import React from 'react';
import { styled } from '@mui/system';
import { useThemeContext } from '../context/ThemeContext';

const Bar = styled('span')(({ color }) => ({
    display: 'inline-block',
    border: '2px solid',
    width: '3px',
    marginRight: '2px',
    //   backgroundColor: color,
}));
const barHeight = [5, 8, 11, 15, 18]; // Heights for the bars based on signal strength

const SignalStrength = ({ bars }) => {
    const { mode } = useThemeContext();

    const getBarColor = () => {
        if (bars >= 4) {
            return 'green';  // Use green for bars 4 and 5
        } else if (bars >= 2 && bars <= 3) {
            return '#FFB300'; // Use yellow for bars 2 and 3
        } else {
            return 'red';    // Use red for 1 bar
        }
    };
    let barColor = getBarColor();
    let unusedBarColor = mode === 'light' ? '#ccc' : '#cccccc66';
    return (
        <span sx={{ borderBottom: `2px solid ${barColor}` }}>
            {[...Array(5)].map((_, level) => (
                <Bar key={level} color={barColor}
                    sx={{
                        height: `${barHeight[level]}px`,
                        borderColor: bars > level ? barColor : unusedBarColor
                    }} />
            ))}
        </span>
    );
};

export default SignalStrength;
